export default __webpack_public_path__ + "static/media/leak-icon.2bfa65c4.svg";